import React from 'react';
import { Col, Form, Input, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { TranslateFormLabel } from 'components/translateInputAddon';

const InfoSection = ({ isView, form }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Info')}</Typography.Title>
      </Col>
      <Col span={6}>
        <Form.Item
          label={
            <TranslateFormLabel
              label={t('Titolo IT')}
              form={form}
              sourceField='title_it'
              textKey='title'
              targetFields={{ en: 'title_en', fr: 'title_fr' }}
              disabled={isView}
            />
          }
          name='title_it'
          rules={[
            {
              required: true,
              message: t('Title non può essere lasciato in bianco'),
            },
          ]}
        >
          <Input disabled={isView} placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item label={t('Titolo EN')} name='title_en'>
          <Input disabled={isView} placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item label={t('Titolo FR')} name='title_fr'>
          <Input disabled={isView} placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col offset={6} span={18}>
        <Form.Item
          label={t('Richiedente')}
          name='author'
          rules={[
            {
              required: true,
              message: t('Richiedente non può essere lasciato in bianco'),
            },
          ]}
        >
          <Input disabled={isView} placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(InfoSection);
